"use client";

import FeaturesSection from "~/components/_pages/home/features";
import AboutSection from "~/components/_pages/about/about";
import HowItWorksSection from "~/components/_pages/about/works";
import SayMyName from "~/components/_pages/about/saymyname";

export default function Consume() {
  return (
    <main>
      <AboutSection />
      <SayMyName />
      <HowItWorksSection />
      <FeaturesSection />
    </main>
  )
}
